module.exports = __webpack_public_path__ + "static/media/externalBarn_3.0b83789d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_3.png
// module id = 1307
// module chunks = 3